(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    var sticky = document.querySelector('[data-pdp-sticky]');
    if (!sticky) return;
    var mainBtn = document.querySelector('product-form button[name="add"]');
    if (!mainBtn) return;

    // IntersectionObserver: reveal sticky when main ATC is OUT of view
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        sticky.hidden = false;
        sticky.setAttribute('data-visible', visible ? 'true' : 'false');
      });
    }, { threshold: 0, rootMargin: '-40px 0px 0px 0px' });
    obs.observe(mainBtn);

    // Sticky button → submit main product form via AJAX
    var stickyBtn = sticky.querySelector('[data-pdp-sticky-btn]');
    var formId = stickyBtn && stickyBtn.getAttribute('data-target-form');
    var mainForm = document.getElementById(formId);

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open(stickyBtn);
      else if (drawer && drawer.classList) drawer.classList.add('active');
      else window.location.href = '/cart';
    }

    stickyBtn && stickyBtn.addEventListener('click', function () {
      if (!mainForm) {
        mainBtn.click();
        return;
      }
      var origLabel = stickyBtn.textContent;
      stickyBtn.disabled = true;
      stickyBtn.textContent = 'Adding…';
      var fd = new FormData(mainForm);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          stickyBtn.textContent = 'Out of stock';
          setTimeout(function () { stickyBtn.textContent = origLabel; stickyBtn.disabled = false; }, 1800);
          return;
        }
        stickyBtn.textContent = '✓ Added';
        // update cart bubble
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var bubble = document.querySelector('cart-icon-bubble');
            if (bubble) {
              var count = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
              if (count) count.textContent = cart.item_count;
            }
          });
        openCartDrawer();
        setTimeout(function () { stickyBtn.textContent = origLabel; stickyBtn.disabled = false; }, 1400);
      })
      .catch(function () {
        stickyBtn.textContent = 'Try again';
        stickyBtn.disabled = false;
      });
    });

    // Update sticky price when variant changes
    var priceEl = sticky.querySelector('[data-pdp-sticky-price]');
    document.addEventListener('variant:change', function (e) {
      if (!priceEl || !e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<s>' + formatMoney(v.compare_at_price) + '</s> ';
      }
      html += '<strong>' + formatMoney(v.price) + '</strong>';
      priceEl.innerHTML = html;
    });
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-trust-row"] && !Shopify.designMode) return;
  try {
    // Real "arrives by" range. Handling is 1-2 business days, transit 2-5, // the same numbers the Product schema publishes, so page and markup agree.
  (function () {
    var el = document.querySelector('[data-pdp-eta]');
    if (!el) return;

    function addBusinessDays(from, n) {
      var d = new Date(from.getTime());
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) added++;
      }
      return d;
    }

    var now = new Date();
    var minArr = addBusinessDays(now, 3); // 1 day handling + 2 days transit
    var maxArr = addBusinessDays(now, 7); // 2 days handling + 5 days transit
    var fmt = function (d) {
      return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    };
    el.textContent = 'Free US shipping · arrives ' + fmt(minArr) + ' to ' + fmt(maxArr);
  })();
  } catch(e) { console.error(e); }
})();

})();
